
import React from 'react';
import { Progress } from '@/components/ui/progress';
import { cn } from '@/lib/utils';

interface ProcessingIndicatorProps {
  status: 'pending' | 'processing' | 'completed' | 'failed';
  progress?: number;
  className?: string;
}

export default function ProcessingIndicator({
  status,
  progress = 0,
  className
}: ProcessingIndicatorProps) {
  // Status colors
  const statusColors = {
    pending: 'bg-muted-foreground',
    processing: 'bg-video-blue',
    completed: 'bg-green-500',
    failed: 'bg-destructive'
  };

  // Status text
  const statusText = {
    pending: 'Pending',
    processing: `Processing: ${progress}%`,
    completed: 'Completed',
    failed: 'Failed'
  };

  return (
    <div className={cn('flex flex-col gap-1', className)}>
      {status === 'processing' ? (
        <>
          <div className="flex justify-between text-xs">
            <span>{statusText[status]}</span>
            <span>{progress}%</span>
          </div>
          <Progress value={progress} className="h-1.5" />
        </>
      ) : (
        <div className="flex items-center gap-2">
          <div className={cn('h-2 w-2 rounded-full', statusColors[status])} />
          <span className="text-xs">{statusText[status]}</span>
        </div>
      )}
    </div>
  );
}
